import { Mold } from 'src/app/api/elite/types/mold';
import { MoldLocation } from 'src/app/api/elite/types/mold-location';
import { MoldRevision } from '../../../api/elite/types/mold-revision';
import { SchedulerBaseItem } from '../../scheduler/models/item';
import { MoldRevisionCompressionCavity } from '../../../api/elite/types/mold-compression';

export class MoldRevisionItem
  extends SchedulerBaseItem
  implements MoldRevision
{
  get priority(): boolean {
    throw new Error('Method not implemented.');
  }
  set priority(val: boolean) {
    throw new Error('Method not implemented.');
  }
  TYPE: string;
  location: MoldLocation;
  id: number;
  suffix: string;
  private _rank: string;
  public get rank(): string {
    return this._rank;
  }
  public set rank(value: string) {
    this._rank = value;
  }
  moldId: number;
  locationId: number;
  cyclesNumber: number;
  cyclesAfterLastRepair: number;
  mold: Mold;
  active: boolean;

  lastMovement: Date | string;

  get locationName(): string {
    const parent = this.location.parentLocation?.title;
    const grandFather = this.location.parentLocation?.parentLocation?.title;
    return `${grandFather ? grandFather + ' | ' : ''}${
      parent ? parent + ' | ' : ''
    }${this.location.title}`;
  }

  get title(): string {
    return `${this.mold.name} - ${this.suffix}`;
  }

  get typeOfMold(): string {
    return this.mold?.details?.type?.title;
  }
  get reachingRepairLimit(): boolean {
    return (
      this.cyclesAfterLastRepair >=
      this.mold.cyclesForRepair - this.mold.cyclesForRepair * 0.15
    );
  }

  get needsRepair(): boolean {
    return this.cyclesAfterLastRepair >= this.mold.cyclesForRepair;
  }
  get compressionCavities(): MoldRevisionCompressionCavity[] {
    return this.mold.compressionVersions[0].cavities.map((cav) =>
      cav.moldRevisionsData.find((el) => el.moldRevisionId === this.id)
    );
  }

  static fromObject(obj: MoldRevision): MoldRevisionItem {
    const newObj = new MoldRevisionItem();
    Object.assign(newObj, obj);
    newObj.lastMovement = new Date(obj.lastMovement);
    return newObj;
  }
}
